import React, { useEffect, useState } from "react";
import { OfflineStatusContext } from "../utilities/useOfflineStatus";
import axios from 'axios';
import { LoadingPage } from "./LoadingPage";

interface OfflineStatusProviderProps {
}

export function OfflineStatusProvider(props: React.PropsWithChildren<OfflineStatusProviderProps>){
    const [isOffline, setIsOffline] = useState<boolean | undefined>();

    React.useEffect(() => {
		async function ping(){
            try {
                const response = await axios.get("/ping", { headers: { Pragma: 'no-cache' } });
                setIsOffline(response.status !== 200);
            }
            catch {
                setIsOffline(true)
            }
		}

		if(!navigator.onLine){
			setIsOffline(true);
		} else{
            ping()
        }
	}, [])

    useEffect(() => {
		function onBrowserOnline() {
			setIsOffline(false);
		}

		function onBrowserOffline() {
            setIsOffline(true);
		}

		window.addEventListener("offline", onBrowserOffline);
		window.addEventListener("online", onBrowserOnline);

		return () => {
			window.removeEventListener("offline", onBrowserOffline);
			window.removeEventListener("online", onBrowserOnline);
		};
	}, []);


    if(isOffline === undefined){
		return <LoadingPage />;
	}

    return (
        <OfflineStatusContext.Provider value={isOffline}>
            {props.children}
        </OfflineStatusContext.Provider>
    );
}